import React from "react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import BrandSliderImg1 from "../../assets/images/brand/client-Logo-0_0030_01.jpg";
import BrandSliderImg2 from "../../assets/images/brand/client-Logo-0_0029_02.jpg";
import BrandSliderImg3 from "../../assets/images/brand/client-Logo-0_0028_03.jpg";
import BrandSliderImg4 from "../../assets/images/brand/client-Logo-0_0027_04.jpg";
import BrandSliderImg5 from "../../assets/images/brand/client-Logo-0_0026_05.jpg";
import BrandSliderImg6 from "../../assets/images/brand/client-Logo-0_0025_06.jpg";
import BrandSliderImg7 from "../../assets/images/brand/client-Logo-0_0024_07.jpg";
import BrandSliderImg8 from "../../assets/images/brand/client-Logo-0_0023_08.jpg";
import BrandSliderImg9 from "../../assets/images/brand/client-Logo-0_0022_09.jpg";
import BrandSliderImg10 from "../../assets/images/brand/client-Logo-0_0021_10.jpg";
import BrandSliderImg11 from "../../assets/images/brand/client-Logo-0_0020_11.jpg";
import BrandSliderImg12 from "../../assets/images/brand/client-Logo-0_0019_12.jpg";
import BrandSliderImg13 from "../../assets/images/brand/client-Logo-0_0018_13.jpg";
import BrandSliderImg14 from "../../assets/images/brand/client-Logo-0_0017_14.jpg";
import BrandSliderImg15 from "../../assets/images/brand/client-Logo-0_0016_15.jpg";
import BrandSliderImg16 from "../../assets/images/brand/client-Logo-0_0015_16.jpg";
import BrandSliderImg17 from "../../assets/images/brand/client-Logo-0_0014_17.jpg";
import BrandSliderImg18 from "../../assets/images/brand/client-Logo-0_0013_18.jpg";
import BrandSliderImg19 from "../../assets/images/brand/client-Logo-0_0012_19.jpg";
import BrandSliderImg20 from "../../assets/images/brand/client-Logo-0_0011_20.jpg";
import BrandSliderImg21 from "../../assets/images/brand/client-Logo-0_0010_21.jpg";
import BrandSliderImg22 from "../../assets/images/brand/client-Logo-0_0009_22.jpg";
import BrandSliderImg23 from "../../assets/images/brand/client-Logo-0_0008_23.jpg";
import BrandSliderImg24 from "../../assets/images/brand/client-Logo-0_0007_24.jpg";
import BrandSliderImg25 from "../../assets/images/brand/client-Logo-0_0006_25.jpg";
import BrandSliderImg26 from "../../assets/images/brand/client-Logo-0_0005_26.jpg";
import BrandSliderImg27 from "../../assets/images/brand/client-Logo-0_0004_27.jpg";
import BrandSliderImg28 from "../../assets/images/brand/client-Logo-0_0003_28.jpg";
import BrandSliderImg29 from "../../assets/images/brand/client-Logo-0_0002_29.jpg";
import BrandSliderImg30 from "../../assets/images/brand/client-Logo-0_0001_30.jpg";
import BrandSliderImg31 from "../../assets/images/brand/client-Logo-0_0000_31.jpg";

const swiperOptions = {
  modules: [Autoplay, Pagination, Navigation],
  spaceBetween: 100,
  slidesPerView: 5,
  loop: true,
  navigation: {
    nextEl: "#brand-one__swiper-button-next",
    prevEl: "#brand-one__swiper-button-prev",
  },
  autoplay: { delay: 5000 },
  breakpoints: {
    0: {
      spaceBetween: 30,
      slidesPerView: 1,
    },
    375: {
      spaceBetween: 30,
      slidesPerView: 1,
    },
    575: {
      spaceBetween: 30,
      slidesPerView: 2,
    },
    767: {
      spaceBetween: 50,
      slidesPerView: 3,
    },
    991: {
      spaceBetween: 50,
      slidesPerView: 4,
    },
    1199: {
      spaceBetween: 100,
      slidesPerView: 5,
    },
  },
};

export default function BrandSlider1() {
  return (
    <Swiper {...swiperOptions} className="thm-swiper__slider swiper-container">
      <div className="swiper-wrapper">
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg1} alt="Brand 1" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg2} alt="Brand 2" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg3} alt="Brand 3" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg4} alt="Brand 4" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg5} alt="Brand 5" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg6} alt="Brand 6" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg7} alt="Brand 7" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg8} alt="Brand 8" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg9} alt="Brand 9" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg10} alt="Brand 10" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg11} alt="Brand 11" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg12} alt="Brand 12" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg13} alt="Brand 13" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg14} alt="Brand 14" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg15} alt="Brand 15" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg16} alt="Brand 16" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg17} alt="Brand 17" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg18} alt="Brand 18" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg19} alt="Brand 19" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg20} alt="Brand 20" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg21} alt="Brand 21" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg22} alt="Brand 22" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg23} alt="Brand 23" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg24} alt="Brand 24" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg25} alt="Brand 25" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg26} alt="Brand 26" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg27} alt="Brand 27" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg28} alt="Brand 28" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg29} alt="Brand 29" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg30} alt="Brand 30" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg31} alt="Brand 31" />
        </SwiperSlide>
        {/* Repeat slides as necessary */}
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg1} alt="Brand 1" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg2} alt="Brand 2" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg3} alt="Brand 3" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg4} alt="Brand 4" />
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <img src={BrandSliderImg5} alt="Brand 5" />
        </SwiperSlide>
      </div>
    </Swiper>
  );
}
